import React from "react";

export function GochiKidGroupNoteModal(props) {
  return (
    <div
      className={
        props.showing
          ? "custom-modal-container gochi-kid-group-note-modal show-modal"
          : "custom-modal-container gochi-kid-group-note-modal"
      }
      size="sm"
    >
      <div
        className={
          props.showing
            ? "modal modal-action modal-dialog is-show history-modal"
            : "modal modal-action modal-dialog history-modal"
        }
      >
        <div className="title-modal title-modal-charge">
          <div className="title color-EC4A56">ご利用の重要事項</div>
        </div>
        <div className="modal-body">
          この度は「ビーンズ武蔵中原こどもごちめし」をご利用いただきありがとうございます。
          <br />
          ご利用前に以下の重要事項を必ずご確認ください。
          <br />
          <ul>
            <li className="red-mark">
              <span className="color-EC4A56">チケット金額</span>
              : こどもごちめし電子チケットの価格は
              <span className="color-EC4A56">1,000円</span>です。
            </li>
            <li className="red-mark">
              <span className="color-EC4A56">メニュー利用条件</span>
              : 店舗でご利用の際は、メニュー
              <span className="color-EC4A56">価格が1,000円以上</span>
              のメニューをお選びください。1,000円未満のメニューにはご利用いただけません。
            </li>
            <li className="red-mark">
              <div>
                <span className="color-EC4A56">追加料金について</span>
                : サービス価格が1,000円を上回る場合は、
                <span className="color-EC4A56">
                  現地にて差額分を必ずお支払い
                </span>
                ください。
              </div>
              <ul>
                <li>
                  例:
                  1,500円のサービスをご利用の場合、差額の500円をお支払いいただきます。
                </li>
              </ul>
            </li>
            <li className="red-mark">
              <span className="color-EC4A56">お釣り（ご返金）について</span>
              : 本チケットの金額がメニュー価格を上回る場合でも、
              <span className="color-EC4A56">
                お釣り（差額の返金）は出ません
              </span>
              のであらかじめご了承ください
            </li>
          </ul>
        </div>
        <div className="modal-footer">
          <button
            onClick={() => props.handleSubmit()}
            className="btn btn-rect btn-submit"
          >
            確認しました
          </button>
        </div>
      </div>
      <div className="back-drop" onClick={() => props.setShowGochiKidGroupNoteModal(false)} />
    </div>
  );
}
